import { z } from 'zod'
import { oc } from '@orpc/contract'

export const recordsFacilityLink = oc
  .route({ method: 'POST', path: '/v2/facility/link' })
  .input(
    z.object({
      organizationId: z.string(),
      // Details the CC entered in the add-facility form. Used ONLY to fill in
      // fields the linked Organization is MISSING (e.g. a fax it never had) —
      // existing values are never overwritten, since these orgs are shared
      // with the labs/rads flows.
      details: z
        .object({
          street: z.string().optional(),
          city: z.string().optional(),
          state: z.string().optional(),
          zip: z.string().optional(),
          fax: z.string().optional(),
          phone: z.string().optional(),
        })
        .optional(),
    }),
  )
  .output(
    z.object({
      id: z.string(),
      alreadyLinked: z.boolean(),
      // Names of fields that were absent on the org and got filled from
      // `details` (e.g. ['fax']) — lets the UI tell the CC what was saved.
      filledFields: z.array(z.string()),
    }),
  )
